export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9975.41b03a43.jpg";